import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { DefaultValuesService } from "../../../services/defaultvalues.service";
import { Utils } from "../../../utils/utils";
@Component({
    selector: "allowedactionscontrollertype",
    templateUrl: 'allowedactionscontrollertype.component.html',
    standalone: false
})

export class AllowedActionControllerTypeComponent implements OnInit, OnDestroy {

    @Input('commands') commandList: Command[] = [];
    @Input('isEditableMethod') isEditable: any
    @Output() onReloadTemplate = new EventEmitter<any>();

    list: CommandConfigControllerType[] = [];
    mergedList: any[] = [];

    showLocalFilter = false;

    subscriptionControllerType: any;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
        public defaults: DefaultValuesService
    ) { }

    ngOnInit(): void {
        this.subscriptionControllerType = this.defaults.controllerTypeMessageChanges$.subscribe(() => { this.getCommandConfigControllerType() });
        if (this.defaults.tenant && this.commandList.length > 0) {
            this.getCommandConfigControllerType()
        }
    }
    ngOnChanges() {
        this.getCommandConfigControllerType()
    }

    ngOnDestroy() {
        this.subscriptionControllerType.unsubscribe();
    }

    onReload($event) {
        this.onReloadTemplate.emit({});
        const local = this.mergedList
        const local2: any[] = []
        this.mergedList = []
        local.forEach(x => {
            if (x.CommandId === $event.CommandId) {
                x.IsSupported = $event.IsSupported;
                x.FirstActivationUtc = $event.FirstActivationUtc;
                x.LastChangeUtc = $event.LastChangeUtc;
            }
            local2.push(x)
        })
        this.mergedList = local2.sort((a, b) => (+b.IsSupported) - (+a.IsSupported) || a.CommandId - b.CommandId);
    }

    getCommandConfigControllerType() {
        Utils.httpGetCommandConfigControllerType(
            this.http,
            this.baseUrl,
            this,
            function (tthis: AllowedActionControllerTypeComponent, list: CommandConfigControllerType[]) {
                tthis.list = list;
                const tempList: any[] = [];
                tthis.commandList
                    .filter(x => !x.TargetChannel || x.TargetChannel?.toUpperCase() !== 'GATEWAY')
                    .map(x => {
                    const item = tthis.list.find(y => y.CommandId === x.CommandId);
                        return {
                            'IsSupported': item ? item.IsSupported : false,
                            'FirstActivationUtc': item ? item.FirstActivationUtc : '',
                            'LastChangeUtc': item ? item.LastChangeUtc : '',
                            ...x
                        };
                    })
                    .forEach(x => {
                        if (!tempList.some(y => y.CommandId === x.CommandId)) {
                            tempList.push(x);
                        }
                    });
                tthis.mergedList = tempList.sort((a, b) => (+b.IsSupported) - (+a.IsSupported) || a.CommandId - b.CommandId);
            }
        );
    }
}
